export default "__VITE_ASSET__BFQ7qdN7__"